import { createContext, useContext } from 'react';
import type { MerchantReceiptItem } from '../service/types';

export interface ReceiptsResultsContextValue {
  isTableLoading: boolean;
  isError: boolean;
  isRetrying: boolean;
  error: unknown;
  rows: MerchantReceiptItem[];
  hasAnyRows: boolean;
  showPagination: boolean;
  pageItems: Array<number | 'ellipsis'>;
  pageNumber: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onPageChange: (nextPage: number) => void;
  onRetry: () => void;
}

export const receiptsResultsContext = createContext<ReceiptsResultsContextValue | null>(null);

export function useReceiptsResults() {
  const value = useContext(receiptsResultsContext);
  if (value === null) {
    throw new Error('useReceiptsResults must be used within ReceiptsPageProvider');
  }
  return value;
}
